/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2023. All Rights Reserved.
 #*
 #*===================================================================
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TenantApiManagementConfigDTO } from '@client-details/api-management/shared';
import { environment } from 'environments/environment';
import { ApiResponse } from '@core/models';

@Injectable({ providedIn: 'root' })
export class TenantApiManagementService {
  constructor(private http: HttpClient) {}

  getConfigs(tenantId: string): Observable<ApiResponse<TenantApiManagementConfigDTO[]>> {
    return this.http.get<ApiResponse<TenantApiManagementConfigDTO[]>>(
      `${environment.superAdmin}/tenant-api-management/${tenantId}`
    );
  }

  createConfig(payload: Partial<TenantApiManagementConfigDTO>): Observable<ApiResponse<TenantApiManagementConfigDTO>> {
    return this.http.post<ApiResponse<TenantApiManagementConfigDTO>>(
      `${environment.superAdmin}/tenant-api-management`,
      payload
    );
  }

  updateConfig(payload: Partial<TenantApiManagementConfigDTO>): Observable<ApiResponse<TenantApiManagementConfigDTO>> {
    return this.http.put<ApiResponse<TenantApiManagementConfigDTO>>(
      `${environment.superAdmin}/tenant-api-management/${payload.id}`,
      payload
    );
  }

  deleteConfig(id: number): Observable<ApiResponse<number>> {
    return this.http.delete<ApiResponse<number>>(`${environment.superAdmin}/tenant-api-management/${id}`);
  }
}
